import { Injectable } from '@angular/core';
import { Application } from '../models/Application.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApplicationApiService {
  private apiUrl = 'api/applications';

  constructor(private httpClient: HttpClient) {}

  getApplications() {
    return this.httpClient.get<Application[]>(`${this.apiUrl}`);
  }

  getFilesById(id: string) {
    return this.httpClient.get<any[]>(`${this.apiUrl}/GetFilesByID/` + id);
  }
  applicationToJSON(application: Application) {
    return this.httpClient.post(
      this.apiUrl + '/SaveApplicationToJSON',
      application
    );
  }

  updateApplicationById(application: Application) {
    return this.httpClient.post(
      this.apiUrl + '/updateApplication',
      application
    );
  }

  addApplicationFiles(files: any) {
    return this.httpClient.post(this.apiUrl + '/addApplicationFiles', files);
  }

  mailDeclineApplications(data: string) {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify({ year: data });
    console.log(body);
    return this.httpClient.post('api/Mail', body, { headers: headers });
  }
}
